import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import HomePage from "./pages/Home";
import About from "./pages/AboutPage";
import WhyVastavik from "./pages/WhyVastavik";
import TermsandCondition from "./pages/TermsandCondition";
import Howitworks from "./pages/HowitWorks";
import ContactUs from "./pages/ContactUs";
import CreatorsPanel from "./pages/CreatorsPanel";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import OfflineNotice from "./components/OfflineNotice";
import { useOnlineStatus } from "./hooks/useOnlineStatus";

// Import the Verification Result component and the individual data objects
import VerificationResult, {
  sampleVerificationResult, // Booking
  expediaVerificationResult,
  airbnbVerificationResult,
  agodaVerificationResult,
} from "./pages/VerificationResult";

function VerifyPage() {
  const { ownerKey } = useParams<{ ownerKey: string }>();
  return <HomePage initialOwnerKey={ownerKey} />;
}

export default function App() {
  const online = useOnlineStatus();

  // No connection → show the offline page instead of a route that can't load.
  if (!online) {
    return <OfflineNotice />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/whyvastavik" element={<WhyVastavik />} />
        <Route path="/termsandcondition" element={<TermsandCondition />} />
        <Route path="/howitworks" element={<Howitworks />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/creators-panel" element={<CreatorsPanel />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:postId" element={<BlogPost />} />
        <Route path="/verify/:ownerKey" element={<VerifyPage />} />
        
        {/* Verification Result Routes for individual demos */}
        <Route path="/vw/booking-com-demo" element={<VerificationResult data={sampleVerificationResult} />} />

        <Route path="/vw/expedia-demo" element={<VerificationResult data={expediaVerificationResult} />} />

        <Route path="/vw/airbnb-demo" element={<VerificationResult data={airbnbVerificationResult} />} />
        
        <Route path="/vw/agoda-demo" element={<VerificationResult data={agodaVerificationResult} />} />

      </Routes>
    </BrowserRouter>
  );
}